import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { get, capitalize } from 'lodash';
import { FormattedMessage } from 'react-intl';

const ContinuityPlanInPlace = ({ classes, user, obfuscateView }) => {
  if (get(user, 'business_continuity_state')) {
    return (
      <div className={classes.status}>
        <strong className={classes.title}>
          <FormattedMessage id="profile_page.continuity_plan_in_place"/>
        </strong>
        {!obfuscateView && <p className={classes.description}>{get(user, 'business_continuity_state')}</p>}
        {obfuscateView && <p className="blurry-text">???</p>}
      </div>
    );
  }
  return <div />;
};

const styles = {
  status : {
    marginBottom : 15,
    width        : 170,
    border: '1px solid transparent',
    borderRadius: 8,
    padding: 12,
    transition: 'background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease'
  },
  title: {
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '8px',
    transition: 'color 0.3s ease',
    display: 'block'
  },
  description: {
    fontSize: '13px',
    margin: 0,
    transition: 'color 0.3s ease'
  }
};

export default withStyles(styles)(ContinuityPlanInPlace);
